/**
 * Get list of all rights defined on the application
 * @returns Array of strings
 */
export const getRights = () => {
  return window.ITREF.config.rights.data || [];
};
